<div class="card">
    <div class="card-header">
        <div class="row">
          <div class="col-6">
            <label for="upload">Choose a text file of specimen numbers:</label>
            
          </div>
          <div class="col-6">
            <input type="file" id="upload" accept=".txt;.csv" (change)="uploadList($event.target.files)" ngbTooltip="upload a text file list of sample numbers." />
          </div>
        </div>
    </div>
</div>
